import { useQuery } from "react-query";
import { REQUEST_SIGNUP_OTP } from "../appConstants/APIEndpoint";
import { requestApiPostTwo } from "./index";

export const requestOtp = async (
  phoneNumber: string,
  action: string,
  userResendOtp: boolean,
  language: string
) => {
  const body = {
    phoneNumber,
    action,
    userResendOtp,
    appPackageName: "com.eight.network.android.vertical",
  };
  const config = { language };
  try {
    const responseData = await requestApiPostTwo(REQUEST_SIGNUP_OTP, body, config);
    return responseData.response;
  } catch (error) {
    console.error("Error requesting OTP:", error);
    throw error;
  }
};

export const useRequestOtpApi = (
  phoneNumber: string,
  action: string,
  userResendOtp: boolean,
  language: string
) => {
  const { refetch, data, isLoading, error, isError } = useQuery({
    queryKey: ["requestOtpApi", phoneNumber, action, userResendOtp, language],
    queryFn: () => requestOtp(phoneNumber, action, userResendOtp, language),
    staleTime: 0,
    enabled: false, // We're setting it false so it's called only using refetch
  });

  return {
    otpData: data,
    isLoadingOTP: isLoading,
    errorOTP: error,
    isErrorOTP: isError,
    refetchOTP: refetch,
  };
};